<template>
  <div class="text-center redirect-div">
    Loggin in with SSO Authentication...
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vuecookie from 'vue-cookies'
  import { backendUrl } from '@/helpers/backendUrl.js'

export default {
  name: 'ssoLogin',
  data() {
    return {
      isBusy: false
    }
  },
  beforeMount() {
    if(!this.isBusy) {

      this.$store.commit('logIn', this.$route.params.token)

      if(process.env.VUE_APP_STATUS && process.env.VUE_APP_STATUS == 'localhost' && this.$route.params.token) {
        vuecookie.set('token', this.$route.params.token, 60*60*2)
      } else {
        vuecookie.set('token', this.$route.params.token, 60*60*2, null, null, true)
      }
      this.isBusy = true

      this.$store.dispatch('loginWithToken').then(() => {
        setTimeout(() => {
          this.$router.push('/')
        }, 3000);
      }).catch( error => {
        console.log('SSO login error')
        console.log(error)
        /*if(error.response.status == 401) {
            vuecookie.remove('token')
            window.location.replace(`${backendUrl()}` + '/sso')
        } */
      })
    }
  }
}
</script>

<style scoped>
.redirect-div {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>